var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInstantEft(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#003750",
    height: 56,
    viewBox: "0 0 64 56",
    width: 64,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(131 -4)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(-100 8.001)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-71,4h-56a4.012,4.012,0,0,0-4,4V48a4.012,4.012,0,0,0,4,4h20.39l-.365,4.472c0,.036-.081.857-1.266,1.528H-110a1,1,0,0,0-1,1,1,1,0,0,0,1,1h22a1,1,0,0,0,1-1,1,1,0,0,0-1-1h-1.759c-1.185-.671-1.265-1.5-1.269-1.581L-91.389,52H-71a4.012,4.012,0,0,0,4-4V8A4.012,4.012,0,0,0-71,4Zm-34.429,54a3.019,3.019,0,0,0,.45-1.418L-104.6,52H-93.4l.371,4.5a3.178,3.178,0,0,0,.46,1.5ZM-69,48a2,2,0,0,1-2,2h-56a2,2,0,0,1-2-2V42h60Zm0-8h-60V8a2,2,0,0,1,2-2h56a2,2,0,0,1,2,2Z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(-101 43.999)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstantEft);
export default __webpack_public_path__ + "static/media/instant-eft.51670c4b7d78d3168b19d14187d14fd6.svg";
export { ForwardRef as ReactComponent };